module.exports = __webpack_public_path__ + "static/img/goal-06.360bff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/goal-06.png
// module id = Nq6M
// module chunks = 2